import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VigiRoutingModule } from './vigi-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    VigiRoutingModule
  ]
})
export class VigiModule { }
